import { render, staticRenderFns } from "./SavePanelView.vue?vue&type=template&id=fcb89f16&scoped=true&"
import script from "./SavePanelView.vue?vue&type=script&lang=js&"
export * from "./SavePanelView.vue?vue&type=script&lang=js&"
import style0 from "./SavePanelView.vue?vue&type=style&index=0&id=fcb89f16&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcb89f16",
  null
  
)

export default component.exports